/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["underscore", "jquery", "utils/string"], function(_, $, StringUtils) {
  var loadPlugins = function() {
    const resourceUrl = Mindbreeze.require.toUrl("api/download").replace(/\?.*/, "");
    const baseUrl = Mindbreeze.require.toUrl("").replace(/\?.*/, "");
    const resourcePath = resourceUrl.replace(baseUrl, "");

    var globalDeferred = $.Deferred();

    function initPlugins(pluginConfig) {
      const appconfig = {};
      const pluginPromises = _.map(pluginConfig, function(config) {
        // accepts only  "contentType": "application/json" for "builtin:appconfig"
        if (config.id.includes("builtin:appconfig") && config.data != null && config.data !== "" && _.isObject(config.data)) {
            let key = config.id.replace("builtin:appconfig:", "");
            key = StringUtils.kebabCaseToCamelCase(key);
            appconfig[key] = config.data;
          return Promise.resolve();
        }

        var pluginsLoadedDeferred = $.Deferred();
        var initRequirements = [];
        var paths = {};
        paths[config.id] = resourcePath + "/" + config.id;
        initRequirements.push(config.id + "/" + config.init);
        var req = Mindbreeze.require.config({ paths: paths });

        req(
          initRequirements,
          function() {
            pluginsLoadedDeferred.resolve();
          },
          function(errors) {
            pluginsLoadedDeferred.resolve();
          }
        );
        return pluginsLoadedDeferred.promise();
      });

      $.when.apply($, pluginPromises).then(
        // done
        function() {
          globalDeferred.resolve(appconfig);
        },
        // error
        function() {
          globalDeferred.resolve(appconfig);
        }
      );
    }

    Mindbreeze.require(["plugin-config"], initPlugins,
      function(err) {
        console.error("Module failed to load:", err.requireModules);
        globalDeferred.resolve([]);
    }
    );

    return globalDeferred.promise();
  };


  return { loadPlugins: loadPlugins };
});
